export { default as default } from './Poster';
